import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const ListView = createSvgIcon(
  <path d="M2.25 2.25H0V4.5h2.25V2.25Zm21.75 0H4.5V4.5H24V2.25ZM4.5 19.5H24v2.25H4.5V19.5Zm-2.25 0H0v2.25h2.25V19.5Zm2.25-8.625H24v2.25H4.5v-2.25Zm-2.25 0H0v2.25h2.25v-2.25Z" />,
  'ListView'
);

export { ListView };